import React, { useState, useEffect, useCallback } from "react";

const CountdownTimer = ({startDate,endDate,showDays = true,showHours = true,showMinutes = true,showSeconds = true, countdownTimerTabData,selectedTemplate }) => {

  const calculateTimeLeft = useCallback(() => {
    const now = new Date();
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (now < start) {
      // Before start date
      return {
        status: "notStarted",
        timeLeft: {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        },
      };
    }

    if (now >= end) {
      // After end date
      return {
        status: "ended",
        timeLeft: {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        },
      };
    }

    // In between start and end
    const difference = end - now;
    return {
      status: "running",
      timeLeft: {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / (1000 * 60)) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      },
    };
  }, [startDate, endDate]);

  const [countdown, setCountdown] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [calculateTimeLeft]);

  const { status, timeLeft } = countdown;

  let countdown_box_font_size = {};
  let countdown_label_font_size = {};
  if (countdownTimerTabData.timer_position_type === "install_to_required_position") {
    countdown_box_font_size = countdownTimerTabData.appearance_timer_size / 0.5 + "px";
    countdown_label_font_size = countdownTimerTabData.appearance_timer_size / 1.4 + "px";
  } else {
    countdown_box_font_size = countdownTimerTabData.appearance_timer_size / 0.9 + "px";
    countdown_label_font_size = countdownTimerTabData.appearance_timer_size / 1.9 + "px";
  }

  // Determine if the temp should be displayed based on the props
  let countdown_box_style = {};
  let countdown_value_style = {};
  let countdown_label_style = {};
  let countdown_top_box_style = {};
  if (selectedTemplate === "Countdown_Timer_Temp") {
       countdown_top_box_style = {
      }
      countdown_box_style = {
                  background: countdownTimerTabData.appearance_colors_timer_color,
                  padding: `${countdownTimerTabData.appearance_timer_size / 2.8}px ${countdownTimerTabData.appearance_timer_size * 0.9}px`,
                  color: countdownTimerTabData.appearance_colors_timer_text_color};
      countdown_value_style = {fontSize: countdown_box_font_size};
      countdown_label_style = {color: countdownTimerTabData.appearance_colors_labels_color,fontSize: countdown_label_font_size};
  } else if (selectedTemplate === "Black_Friday_Sale_Banner_Temp") {
       countdown_top_box_style = {
      }
        countdown_box_style = {
                  background: countdownTimerTabData.appearance_colors_timer_color,   backgroundColor: countdownTimerTabData.appearance_colors_timer_color,
                  color: countdownTimerTabData.appearance_colors_timer_text_color,
                  padding: `${countdownTimerTabData.appearance_timer_size / 2.8}px ${countdownTimerTabData.appearance_timer_size * 0.9}px`,
                  fontSize: countdownTimerTabData.appearance_timer_size + "px"
                };
      countdown_value_style = {
                
               
                };
      countdown_label_style = {
                  color: countdownTimerTabData.appearance_colors_labels_color,
                  fontSize: countdownTimerTabData.appearance_timer_size / 1.2 + "px",
                };
  } else if (selectedTemplate === "Special_Offer_Banner_Temp") {
        countdown_top_box_style = {
      }
     countdown_box_style = {
                  background: countdownTimerTabData.appearance_colors_timer_color,   
                  backgroundColor: countdownTimerTabData.appearance_colors_timer_color,
                  color: countdownTimerTabData.appearance_colors_timer_text_color,
                  padding: `${countdownTimerTabData.appearance_timer_size / 2.8}px ${countdownTimerTabData.appearance_timer_size * 0.9}px`,
                  fontSize: countdownTimerTabData.appearance_timer_size + "px"
                };
      countdown_value_style = {
                };
      countdown_label_style = {
                  color: countdownTimerTabData.appearance_colors_labels_color,
                  fontSize: countdownTimerTabData.appearance_timer_size / 1.2 + "px",
                };
  } else if (selectedTemplate === "Urgency_Countdown_Temp") {
    countdown_top_box_style = {

    }
      countdown_box_style = {  fontSize: countdownTimerTabData.appearance_timer_size / 0.6 + "px",};
      countdown_value_style = { 
                 background: countdownTimerTabData.appearance_colors_timer_color,
                 color: countdownTimerTabData.appearance_colors_timer_text_color,
                  padding: `${countdownTimerTabData.appearance_timer_size / 1.8}px ${countdownTimerTabData.appearance_timer_size * 0.9}px`,
                };
      countdown_label_style = {
                  color: countdownTimerTabData.appearance_colors_labels_color,
                  fontSize: countdownTimerTabData.appearance_timer_size / 1.2 + "px",
                };
  } else if (selectedTemplate === "Event_Start_Countdown_Temp") {
     countdown_top_box_style = { 
                    background: countdownTimerTabData.appearance_colors_timer_color,
                    color: countdownTimerTabData.appearance_colors_timer_text_color,
                    padding: `${countdownTimerTabData.appearance_timer_size / 3.1}px ${countdownTimerTabData.appearance_timer_size * 0.9}px`,
      }
      countdown_box_style = {};
      countdown_value_style = { 
                  fontSize: countdownTimerTabData.appearance_timer_size / 0.3 + "px",
                 
                };
      countdown_label_style = {
        
                  color: countdownTimerTabData.appearance_colors_labels_color,
                  fontSize: countdownTimerTabData.appearance_timer_size / 1 + "px",
                };
  } else if (selectedTemplate === "Limited_Shipping_Banner_Temp") {
     countdown_top_box_style = {
      }
      countdown_box_style = {};
      countdown_value_style = { 
                  background: countdownTimerTabData.appearance_colors_timer_color,
                  color: countdownTimerTabData.appearance_colors_timer_text_color,
                  padding: `${countdownTimerTabData.appearance_timer_size * 1.0}px ${countdownTimerTabData.appearance_timer_size * 1.0}px`,
                  fontSize: countdownTimerTabData.appearance_timer_size + "px",
                };
      countdown_label_style = {
                  color: countdownTimerTabData.appearance_colors_labels_color,
                  fontSize: countdownTimerTabData.appearance_timer_size / 2 + "px",
                };
  } 

  return (
    <div className="countdown-container">
        <div className={`countdown-boxes`} style={{ display: "flex", gap: "20px" }}>
          {showDays && (
            <div
              className="countdown-box" style={countdown_top_box_style}>
                <div className="countdown-value" style={countdown_value_style}>
                    <div className="countdown-value_detail" style={countdown_box_style}>
                      {String(timeLeft.days).padStart(2, "0").split("")[0]}
                    </div>
                    <div className="countdown-value_detail" style={countdown_box_style}>
                      {String(timeLeft.days).padStart(2, "0").split("")[1]}
                    </div>
                  </div>

              <div
                className="countdown-label" style={countdown_label_style}
              >
                {countdownTimerTabData.timer_days_label}
              </div>
            </div>
          )}
        
          {showHours && (
            <div
              className="countdown-box" style={countdown_top_box_style}>
              <div className="countdown-value" style={countdown_value_style}>
                    <div className="countdown-value_detail" style={countdown_box_style}>
                      {String(timeLeft.hours).padStart(2, "0").split("")[0]}
                    </div>
                    <div className="countdown-value_detail" style={countdown_box_style}>
                      {String(timeLeft.hours).padStart(2, "0").split("")[1]}
                    </div>
                  </div>

              <div
                className="countdown-label" style={countdown_label_style}
              >
                {countdownTimerTabData.timer_hours_label}
              </div>
            </div>
          )}
        
          {showMinutes && (
            <div
              className="countdown-box" style={countdown_top_box_style}>
             <div className="countdown-value" style={countdown_value_style}>
                <div className="countdown-value_detail" style={countdown_box_style}>
                  {String(timeLeft.minutes).padStart(2, "0").split("")[0]}
                </div>
                <div className="countdown-value_detail" style={countdown_box_style}>
                  {String(timeLeft.minutes).padStart(2, "0").split("")[1]}
                </div>
              </div>

              <div
                className="countdown-label" style={countdown_label_style}
              >
                {countdownTimerTabData.timer_minutes_label}
              </div>
            </div>
          )}
        
          {showSeconds && (
            <div
              className="countdown-box" style={countdown_top_box_style}>
            <div className="countdown-value" style={countdown_value_style}>
                    <div className="countdown-value_detail" style={countdown_box_style}>
                      {String(timeLeft.seconds).padStart(2, "0").split("")[0]}
                    </div>
                    <div className="countdown-value_detail" style={countdown_box_style}>
                      {String(timeLeft.seconds).padStart(2, "0").split("")[1]}
                    </div>
                  </div>

              <div
                className="countdown-label" style={countdown_label_style}
              >
                {countdownTimerTabData.timer_seconds_label}
              </div>
            </div>
          )}
        </div>  
    </div>
  );
};

export default CountdownTimer;